import { defineMessages } from 'react-intl';

export default defineMessages({
  isLoading: {
    id: 'connection.isLoading',
    defaultMessage: 'Loading...',
  },
  isTakingTooLong: {
    id: 'connection.isTakingTooLong',
    defaultMessage: 'There might be an error',
  },
  sessionStateUnavailable: {
    id: 'connection.sessionStateUnavailable',
    defaultMessage:
      'Unable to verify your session. Please try again in a moment.',
  },
  sessionLoginFailed: {
    id: 'connection.sessionLoginFailed',
    defaultMessage:
      'Sign in did not open a session. Please reload the page or contact your administrator.',
  },
});
